import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlAssessmentComponent } from './control-assessment.component';
import { SharedModule } from '../shared/shared.module';
import { ControlAssessmentRoutingModule } from './control-assessment-routing.module';
import { CategoryComponent } from '../components/category/category.component';
import { SubcategoryComponent } from '../components/subcategory/subcategory.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule  } from 'ngx-bootstrap/tooltip';
import { CommentHistoryModalComponent } from '../components/comment-history-modal/comment-history-modal.component';



@NgModule({
  declarations: [ControlAssessmentComponent, CategoryComponent, SubcategoryComponent, CommentHistoryModalComponent],
  imports: [ CommonModule, ControlAssessmentRoutingModule, SharedModule, ReactiveFormsModule, FormsModule, TooltipModule.forRoot() ],
  exports: [ControlAssessmentComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class ControlAssessmentModule { }
